/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VoucherDto } from '../../models/voucher-dto';

export interface AdminVoucherControllerDelete$Params {
  id: string;
}

export function adminVoucherControllerDelete(http: HttpClient, rootUrl: string, params: AdminVoucherControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VoucherDto>> {
  const rb = new RequestBuilder(rootUrl, adminVoucherControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VoucherDto>;
    })
  );
}

adminVoucherControllerDelete.PATH = '/api/voucher/admin/{id}';
